const LOGGING_EVENTS = {
  CONNECTION_RESTORED: 'connection_restored',
  LEAVING: 'leaving_partner_portal',
}

export default LOGGING_EVENTS
